import { OrdersManager } from "./orders_manager";
export class OrdersManagerUtils {
    constructor() {
        this.$table = $('#main-table');
        console.log("Orders manager utils is here");
        this.initialize();
        this.bundleload();
    }
    initialize() {
        console.log("Orders manager utils is initialized");
        let pthis = this;
        $("#btn-standard-orders").on("click", function () {
            $("#toolbar").data("orderstatus", "standard");
            $(this).parent().find('.btn').removeClass("btn-warning");
            $(this).parent().find('.btn').addClass("btn-primary");
            $(this).addClass('btn-warning');
            pthis.$table.bootstrapTable('refresh');
        });
        $("#btn-standard-cancelled-orders").on("click", function () {
            $("#toolbar").data("orderstatus", "X");
            $(this).parent().find('.btn').removeClass("btn-warning");
            $(this).parent().find('.btn').addClass("btn-primary");
            $(this).addClass('btn-warning');
            pthis.$table.bootstrapTable('refresh');
        });
        $("#btn-standard-blist-orders").on("click", function () {
            $("#toolbar").data("orderstatus", "viewblist");
            $(this).parent().find('.btn').removeClass("btn-warning");
            $(this).parent().find('.btn').addClass("btn-primary");
            $(this).addClass('btn-warning');
            pthis.$table.bootstrapTable('refresh');
        });
        $("#btn-standard-dapagare-orders").on("click", function () {
            $("#toolbar").data("orderstatus", "dapagare");
            $(this).parent().find('.btn').removeClass("btn-warning");
            $(this).parent().find('.btn').addClass("btn-primary");
            $(this).addClass('btn-warning');
            pthis.$table.bootstrapTable('refresh');
        });
        $("#btn-standard-negozio-orders").on("click", function () {
            $("#toolbar").data("orderstatus", "negozio");
            $(this).parent().find('.btn').removeClass("btn-warning");
            $(this).parent().find('.btn').addClass("btn-primary");
            $(this).addClass('btn-warning');
            pthis.$table.bootstrapTable('refresh');
        });
    }
    bundleload() {
        let pthis = this;
        // Status ordini
        var orders_obj = new OrdersManager();
        console.log("Orders manager bundeload");
        // Load additional orders infos
        function loadAdditionaOrderInfos(virtuemart_order_id, order_number, virtuemart_shipmentmethod_id, order_status) {
            return $.ajax({
                type: 'POST',
                url: 'core/ajax/processOrderData.php',
                data: {
                    button: "orderinfos",
                    virtuemart_order_id: virtuemart_order_id,
                    order_number: order_number,
                    virtuemart_shipmentmethod_id: virtuemart_shipmentmethod_id,
                    order_status: order_status
                }
            })
                .done(function (response) {
                const jresponse = JSON.parse(response);
                let company = (jresponse.userinfo.company) ? ' - ' + jresponse.userinfo.company : '';
                let blacklist = ' ';
                if (jresponse.blacklist) {
                    blacklist = '<i class="fas fa-book-dead"></i> BLACKLISTED ';
                }
                let recurrent_customer = '';
                if (parseInt(jresponse.norders) === 1) {
                    recurrent_customer = ' <span class="badge bg-success" title="Nuovo cliente">New</span>';
                }
                else if (parseInt(jresponse.norders) > 1) {
                    recurrent_customer = ' <span class="badge bg-secondary" title="Gia acquistato ' + jresponse.norders + ' volte">' + jresponse.norders + ' ordini</span>';
                }
                let review_status = '';
                let recensione_richiesta = parseInt(jresponse.recensione_richiesta);
                if (recensione_richiesta > 0) {
                    let title = "Inviate " + recensione_richiesta.toString() + " richieste di recensione";
                    if (recensione_richiesta === 1) {
                        title = "Inviata 1 richiesta di recensione";
                    }
                    review_status = ' <span class="badge text-bg-warning" title="' + title + '"><i class="fas fa-star"></i> Review sent</span>';
                }
                $("#order-w-" + virtuemart_order_id + " .contactname").html('<b>' + blacklist + jresponse.userinfo.first_name + ' ' + jresponse.userinfo.last_name + company + '</b>' + recurrent_customer + ' ' + review_status);
                $("#order-w-" + virtuemart_order_id + " .metodo_pagamento").html(jresponse.metodo_pagamento);
                $("#order-w-" + virtuemart_order_id + " .shipment_name").html(jresponse.shipment_name);
                $("#order-w-" + virtuemart_order_id + " .stato-etichetta").attr('title', jresponse.labelinfo.state_code);
                $("#order-w-" + virtuemart_order_id + " .courier_name").html(jresponse.courier_name.toUpperCase());
                $("#order-w-" + virtuemart_order_id + " .state_icon").html(jresponse.state_icon);
                $("#order-w-" + virtuemart_order_id + " .scuola_data").html(jresponse.scuola_data);
                $("#order-w-" + virtuemart_order_id + " .blacklist").html();
                $("#order-w-" + virtuemart_order_id + " .data-fattura").html();
                if (jresponse.userinfo.customer_note) {
                    $("#order-w-" + virtuemart_order_id + " .customer_note").html('<div class="annotation-wrap"><div class="annotation user-annotation"><span class="annotation-info">Nota del cliente</span> <div style="margin-top: -25px;">' + jresponse.userinfo.customer_note + '</div></div></div>');
                }
                if (jresponse.formatted_tracked_shipment.status_class) {
                    $("#order-w-" + virtuemart_order_id + " .tracking-status-wrap a").attr('href', jresponse.tracking_url);
                    $("#order-w-" + virtuemart_order_id + " .tracking-status-wrap a").attr('title', jresponse.formatted_tracked_shipment.description);
                    $("#order-w-" + virtuemart_order_id + " .tracking-status-wrap a").html('<i class="fas ' + jresponse.formatted_tracked_shipment.status_class + '"></i>' + jresponse.formatted_tracked_shipment.status);
                }
                // console.log(jresponse);                    
            });
        }
        function loadAllAdditionaOrderInfos() {
            const promises = [];
            $('[id^=order-w]').each(function (i, el) {
                const virtuemart_order_id = $(el).data('virtuemart_order_id');
                const order_number = $(el).data('order_number');
                const virtuemart_shipmentmethod_id = $(el).data('virtuemart_shipmentmethod_id');
                const order_status = $(el).data('order_status');
                promises.push(loadAdditionaOrderInfos(virtuemart_order_id, order_number, virtuemart_shipmentmethod_id, order_status));
            });
            Promise.all(promises)
                .then(function () {
                $(".search").removeClass("float-right");
                $(".search").addClass("w-100");
                $(".search").append('<div type="button" class="smart-search-info" style="position: absolute;right: 9px;top:-10px;background:#fff;"><i class="far fa-question-circle"></i></div>');
                $(".smart-search-info").on('click', function () {
                    $.ajax({
                        type: 'POST',
                        url: 'core/ajax/ajax_smart_search.php',
                        data: {
                            button: "infos",
                            class: "orders"
                        },
                        success: function (response) {
                            var jresponse = JSON.parse(response);
                            $('body').append('<div class="modal-wrap">');
                            if ($('#modal-wrap').length === 0) {
                                $('body').append('<div id="modal-wrap"></div>');
                            }
                            $("#modal-wrap").html(jresponse.modal);
                            $("#modalSmartSearch").show();
                            // // Clean backdrop
                            $(".modal-backdrop").remove();
                            // // Show modal
                            $('#modalSmartSearch').modal('toggle');
                        },
                    });
                    console.log('all loaded');
                });
            })
                .catch(function (err) {
                console.error('Failed loading order info', err);
            });
        }
        if (($(window).width()) < 700) {
            $(".search").prepend('<button style="border-bottom-right-radius: 0.25rem; border-top-right-radius:0.25rem;" class="btn btn-primary me-2" id="showActions" title="Toggle actions"><i class="fas fa-ellipsis-h"></i></button>');
            // $(".search").removeClass("float-right");
            // $(".search").addClass("w-100");
        }
        $("#showActions").on('click', () => {
            if ($(".fixed-table-toolbar .bs-bars").hasClass('d-block')) {
                $(".fixed-table-toolbar .bs-bars").removeClass('d-block');
            }
            else {
                $(".fixed-table-toolbar .bs-bars").addClass('d-block');
            }
        });
        // Solo dopo aver creato tabella ordini
        $('#main-table').on('post-body.bs.table', function (e) {
            loadAllAdditionaOrderInfos();
            // Update ordini selezionati
            $('[id^="selector-order"]').on('click', function (el) {
                orders_obj.updateSelectedOrders(this);
                orders_obj.printout();
            });
            // Mostra dettagli ordine
            $(".order-wrap .card-header").on('click', function (el) {
                if (!$(el.target).hasClass('tracking-status-link')) {
                    // let order_number = $(this).data('order_number');
                    let divid = 'right-stuff .body';
                    $('#' + divid).html('<div style="text-align: center;padding-top: 10rem;"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
                    $('#right-stuff').addClass('active');
                    $(".overlay").addClass("active");
                    orders_obj.showOrderInDiv($(this).data('order_id'), divid, { 'showfooter': 0 });
                }
            });
            // Mostra dettagli ordine precedente o successivo
            $(".next-prev-right-stuff").on('click', function (el) {
                let seq = $(this).data('order_seq');
                let divid = 'right-stuff .body';
                let this_order_id = $("#right-stuff .body .order").data('virtuemart_order_id');
                let order_id = $("#order-w-" + this_order_id).data(seq + '_order');
                if (order_id > 0) {
                    orders_obj.showOrderInDiv(order_id, divid, { 'showfooter': 0 });
                    $('#right-stuff').addClass('active');
                }
            });
            // Chiude dettagli ordine
            $("#close-right-stuff").on('click', function () {
                $('#right-stuff').removeClass('active');
                $(".overlay").removeClass("active");
                let divid = 'right-stuff .body';
                $('#' + divid).html('');
            });
        });
        $(function () {
            $(".order_id_link").on('click', function () {
                orders_obj.showOrderAsModal($(this).data('order_id'));
            });
        });
        // let $table = $('#main-table');        
        pthis.$table.on('post-body.bs.table', function () {
            $(".order_id_link").on('click', function () {
                orders_obj.showOrderAsModal($(this).data('order_id'));
            });
        });
        // Product package status        
        // $('.dettaglio-prodotti').on('post-body.bs.table', function (e) {     
        //     let id = parseInt(this.id);        
        //     orders_obj.bindUpdateProductPackageStatus(id);
        // });
        // Per evitare che quando clicco su checkbox mi chiuda il dropdown
        $('.dropdown-actions').on('click', function (e) {
            e.stopPropagation();
        });
        // Update status ordini
        $('.btn-status').on('click', function (el) {
            orders_obj.showUpdateOrderStatus(this);
        });
        // Genera ricevuta degli ordini selezionati
        $('.btn-ricevute').on('click', function (el) {
            // orders_obj.printout();
            orders_obj.generateOrderReceipt(this);
        });
        // Genera ricevuta degli ordini selezionati
        $('.btn-ddt').on('click', function (el) {
            // orders_obj.printout();
            orders_obj.generateOrderDDT(this);
        });
        // Modifica le spese di spedizione dell'ordine (toglie/mette)
        $('.btn-toggle-shipping').on('click', function (el) {
            // orders_obj.printout();
            orders_obj.toggleShipping(this);
        });
        // Modifica ordine da Privato a PA e viceversa
        $('.btn-set-as-pa').on('click', function (el) {
            orders_obj.setorderasPA(this);
        });
        // Modifica le spese di spedizione dell'ordine (toglie/mette)
        $(function () {
            $('.btn-edit-tracking-number').on('click', function (el) {
                // orders_obj.printout();
                orders_obj.showEditTrackingNumber();
            });
        });
        // Invia recensioni in batch
        $('.btn-batch-send-review').on('click', function (el) {
            orders_obj.gotoBatchSendReviews();
        });
        // Invia email per chiedere il voucher carta docente
        $('.btn-batch-send-request-voucher').on('click', function (el) {
            orders_obj.gotoBatchSendRequestVoucher();
        });
        // Edita ordine
        $(function () {
            $('.btn-edit-orderdata').on('click', function (el) {
                orders_obj.goToEditOrder();
            });
        });
        // Set stato di pagamento
        $(function () {
            $('.btn-stato-pagamento').on('click', function (el) {
                orders_obj.goToSetStatoPagamento();
            });
        });
        // Rimborsa ordine
        $(function () {
            $('.btn-refund-order').on('click', function (el) {
                orders_obj.goToRefund();
            });
        });
        // Check voucher carta docente
        $(function () {
            $('.btn-check-voucher-docente').on('click', function (el) {
                // orders_obj.printout();
                orders_obj.goToCheckVoucher();
            });
        });
        // Crea fattura
        $(function () {
            $('.btn-crea-fattura').on('click', function (el) {
                // orders_obj.printout();
                orders_obj.gotToCreaFattura();
            });
        });
        // Check carrier button
        $(function () {
            orders_obj.bindCheckBestCarrier();
        });
        // Check carrier button
        $(function () {
            orders_obj.bindCheckPriceCarriers();
        });
        $('.expand-card-body-btn').click(function (el) {
            var $fa = $(this).find('i');
            if ($fa.hasClass('fa-caret-down')) {
                $fa.removeClass('fa-caret-down');
                $fa.addClass('fa-caret-up');
                $(this).parent().css('top', '-30px');
            }
            else if ($fa.hasClass('fa-caret-up')) {
                $fa.removeClass('fa-caret-up');
                $fa.addClass('fa-caret-down');
                $(this).parent().css('top', '-21px');
            }
        });
    }
}
